import { environment } from "environments/environment";

export const featureFlagsAfterSales:Record<string, boolean> = {
    enableRepairCentreRepossessionTicketReassign: true,

}
